import api from '../api';
import { filterProductCategoryBy } from '../helpers';
let apiUrl = 'product-categories';

const state = {
    data: {},
    meta: {}
};

const INACTIVE_CATEGORIES = ['agrarprodukte', 'industriemetalle'];

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    all: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}/all`, config)
            .then((response) => {
                response.data.data = response.data.data.filter((category) => {
                    if (!INACTIVE_CATEGORIES.includes(category.slug.name)) {
                        return category;
                    }
                });
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    }
};

const getters = {
    get: (state) => () => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    },
    getCategoryById: (state) => (id) => {
        return state.data.find((category) => category.id === id);
    },
    getGroupByProductId: (state) => (productId) => {
        return filterProductCategoryBy(productId, state.data);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
